import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { AgGridModule } from '@ag-grid-community/angular';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import { AuthState } from './guards/auth-guard.state';
import { ClickOutsideDirective } from './directives/clickOutside.directive';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

ModuleRegistry.registerModules([ClientSideRowModelModule, CsvExportModule]);

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    NgxsModule.forFeature([AuthState]),
    AgGridModule,
    FontAwesomeModule,
  ],
  declarations: [ClickOutsideDirective],
  exports: [ClickOutsideDirective],
})
export class CommonsModule { }
